import React from "react";
import { Link } from "react-router-dom";

import Pijl from "../Icons/Pijl";
import icons from "../Icons/icons";

import restricted from '../../data/restricted';

import "./Links.scss";


const Links = ({ categorie, links, pages, access, specialindex }) => {
	if (!links) return null;

	const path = categorie === "basis" ? "/" : "/" + categorie + "/";
	const linksClass = specialindex
		? "page-links specialindex-links"
		: "page-links";
	const thisLinks = links.map((link, i) => {
		const page = pages.filter(
			pagina => pagina.naam === link && pagina.categorie === categorie
		)[0];
		const title = page.titel;
		const auth = !(specialindex && restricted.indexOf(link) > -1 && access.indexOf(link) === -1);
		const icon = icons[link] ? icons[link] : null;
		if (auth) {
			return (
				<li key={i} className={"link-" + categorie + "-" + link}>
					<Link to={path + link}>
						{icon}
						<span>{title}</span>
						<Pijl />
					</Link>
				</li>
			);
		} else {
			return (
				<li className={"link-" + categorie + "-" + link + " noaccess"} key={i}>
					{icon}
					{title}
					<Pijl />
				</li>
			);
		}
	});

	return <ul className={linksClass}>{thisLinks}</ul>;
};

export default Links;
